/**
 * Created by Ning Jiang on 2021-05-28.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {Serial} from "../../Serial";
import {gsap} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {IBaseSymbol} from "../../../core/symbol/BaseSymbol";
import {SerialGameMode} from "../../server/SerialGameMode";

export class SymbolLandingController extends ReelStopPresentationController {

    private _animations:gsap.core.Animation[] = [];

    constructor() {
        super("SymbolLandingController");
    }

    protected async onReelBounce(data:IReelStateEventData):Promise<any> {
        const promises:Promise<any>[] = [];
        const symbols:IBaseSymbol[] = [];
        Serial.model.currentSpinPositions[data.reelId].forEach((spinState, symId) => {
            if([0, 1, 5, 6].includes(symId)) {
                return;
            }
            if(!spinState) {
                return;
            }
            if(Serial.model.parsedGameData.mode === SerialGameMode.FREESPIN_SUPER && data.reelId === 4 && symId === Serial.model.parsedGameData.jumpingS2.newRowPos) {
                // symbol lands behind the jumping S2.
                return;
            }
            const symbol = <IBaseSymbol>Serial.getSymbol(data.reelId, symId);
            if(symbol.playLanding && !symbols.includes(symbol)) {
                if(symbol.blockReelLandingSound) {
                    Serial.reelStopSoundController.stopSoundPlayed[data.reelId][0] = true;
                }
                symbols.push(symbol);
                const ani = symbol.playLanding();
                if(ani.totalDuration() > 0) {
                    this._animations.push(ani);
                    promises.push(Promise.resolve(ani).then(res => {
                        ArrayHelper.removeFirstMatchElement(this._animations, ani);
                    }));
                }
            }
        });

        await Promise.all(promises);
        symbols.length = 0;
    }

    protected async onEnhancerReelBounce(data:IReelStateEventData):Promise<any> {
        if(!Serial.enhancerReels[data.reelId][data.positionId].isOpened) {
            return super.onEnhancerReelBounce(data);
        }

        if(!Serial.model.currentSpinPositions[data.reelId][data.positionId]) {
            return super.onEnhancerReelBounce(data);
        }

        const symbol = <IBaseSymbol>Serial.getSymbol(data.reelId, data.positionId);
        if(!symbol.playLanding) {
            return super.onEnhancerReelBounce(data);
        }

        if(symbol.blockReelLandingSound) {
            Serial.reelStopSoundController.stopSoundPlayed[data.reelId][1] = true;
        }

        const ani = symbol.playLanding();
        if(ani.totalDuration() > 0) {
            this._animations.push(ani);
            await Promise.resolve(ani).then(res => {
                ArrayHelper.removeFirstMatchElement(this._animations, ani);
            });
        } else {
            return super.onEnhancerReelBounce(data);
        }
    }
}